export const beforeCapture = 'rnbqkbnr/ppp1pppp/8/3p4/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 1';

export const beforeCaptureBlackToMove = 'rnbqkbnr/ppp1pppp/8/3p4/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - 0 1';

export const beforeCastle = 'r3k2r/pppqbppp/2npbn2/4p3/4P3/2NPBN2/PPPQBPPP/R3K2R w KQkq - 0 1';

export const beforeCastleBlack = 'r3k2r/pppqbppp/2npbn2/4p3/4P3/2NPBN2/PPPQBPPP/R3K2R b KQkq - 0 1';

export const beforeCheck = 'rnbqkbnr/ppppp1pp/5p2/8/8/4P3/PPPP1PPP/RNBQKBNR w KQkq - 0 2';

export const beforeCheckBlack = 'rnbqkbnr/pppp1ppp/8/4p3/8/4PP2/PPPP2PP/RNBQKBNR b KQkq - 0 2';

export const beforeCheckmate = 'rnbqkbnr/pppp1ppp/4p3/8/6P1/5P2/PPPPP2P/RNBQKBNR b KQkq g3 0 2';

export const beforeCheckmateWhite = '7k/4Q3/6K1/8/8/8/8/8 w - - 0 1';

export const beforeEPCapture = '4k3/8/8/3Pp3/8/8/8/4K3 w - e6 0 1';

export const beforeMultipleCaptures = 'rnb1k2r/1pp2pp1/1Q3n2/2bpp3/3PPB2/5Nq1/1PP2PP1/RN2KB1R w KQkq - 0 1';

export const beforePromotion = 'rnbqkb1r/ppppppPp/8/8/8/8/PPPPPP1P/RNBQKBNR w KQkq - 0 1';

export const beforePromotionBlack = 'rnbqkbnr/pppppp1p/8/8/8/8/PPPPPPpP/RNBQKBNR b KQkq - 0 1';

export const beforePromotionCheckmate = '8/Pk1K4/R7/8/8/8/8/8 w - - 0 1';

export const bughouseInitial = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR/ w KQkq - 0 1 | rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR/ w KQkq - 0 1';

export const bughouseAfterCapture = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR/P w KQkq - 0 1 | rnbqkbnr/ppp1pppp/8/8/2P1p3/8/PP1P1PPP/RNBQKBNR/ w KQkq - 4 3';

export const check = 'rnbqkbnr/ppppp1pp/5p2/7Q/8/4P3/PPPP1PPP/RNB1KBNR b KQkq - 1 2';

export const checkmateBlack = 'rn2kb1r/2p1p1pp/p4p2/1pNp4/1P1PP3/2P1n3/P2Q1PqP/R1B1R1K1 w kq - 0 16';

export const checkmateWhite = 'rnb2bnr/pppp2pp/7k/6Q1/2BPP3/8/PPP2PPP/RNB1K2R b K -';

export const crazyhouseAfterCapture = '8/8/2rk4/8/8/8/8/3K4/P W';

export const crazyhouseHandPieceMultiples = 'r1b1kb1r/ppppNppp/8/8/3Qn3/8/PPP2PPP/R1B1KB1R/PP W';

export const crazyhouseDifferentHandpieces = 'r1b1kb1r/ppppNppp/8/8/3Qn3/8/PPP2PPP/R1B1KB1R/PN W';

export const e3 = 'rnbqkbnr/pppppppp/8/8/8/4P3/PPPP1PPP/RNBQKBNR b KQkq - 0 1';

export const e4e5 = 'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq e6 0 2';

export const empty = '8/8/8/8/8/8/8/8 w KQkq - 0 1';

export const enPassant = 'rnbqkbnr/ppp1p1pp/8/3pPp2/8/8/PPPP1PPP/RNBQKBNR w KQkq f6 0 3';

export const fiftyMove = '7k/4N3/5K2/5BN1/8/8/8/r7 b - - 100 113';

export const fiftyMoveCheckmate = '8/8/8/8/4bb2/8/5k2/7K w - - 100 118';

export const initial = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

export const insufficientMaterial = '7k/8/8/8/2N5/8/1K6/8 w - - 0 1';

export const insufficientMaterialBlack = '7k/8/5n2/8/8/8/1K6/8 w - - 0 1';

export const timeoutInsufficientMaterial = '6k1/8/8/5R2/8/8/3K4/8 b';

export const timeoutInsufficientMaterialWhite = '6K1/8/8/5r2/8/8/3k4/8 w';

export const timeoutInsufficientMaterialWhiteToMove = '6k1/8/8/5R2/8/8/3K4/8 w';

export const multipleCaptures = 'rn1qkbnr/ppp3pp/4b3/8/8/8/PPPP1PPP/RNB1KBNR w KQkq - 0 6';

// The next move for white is checkmate, but it's black's turn and black's move will trigger the fifty move rule.
export const beforeFiftyMoveAndCheckmate = '2k5/7R/6R1/8/8/8/2K5/8 b - - 99';

export const stalemate = '7k/5K2/6Q1/8/8/8/8/8 b - - 0 1';

export const threeCheck = 'rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - 0 3 +0+0';

export const whiteCastlePremove = 'rnbqkbnr/pppp1ppp/8/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - 1 3';
